import script from "./fishing-area-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./fishing-area-item.vue?vue&type=script&setup=true&lang=ts"

import "./fishing-area-item.vue?vue&type=style&index=0&id=6a526dd7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a526dd7"]])

export default __exports__